import { config } from '@/config'
import { service, datatrans } from '@/service/index'
import urlWatcher from '@/helpers/urlwatcher'
import { format } from '@/utils/format'
import { setLocalTimezone, formatServer, dayjsLocal } from '@/helpers/dayjs'
import Vue from 'vue'
import scrrroll from "scrrroll"
import {eventhub, EVENT_ACCOUNT_ISLOGGEDIN, EVENT_CART_CREATED, EVENT_CART_TIMECHANGED, EVENT_SHOP_INITIALIZED} from './eventhub'
import getters from './getters'
import { getUrlParams } from '@/utils/urlParams';
import cookie from 'cookie_js'
import { switchDateFormat } from '@/utils/formatDate'


let initializePromise = null

export default {
	async initialize({dispatch, state, commit, getters}) {
		if (initializePromise) {
			return initializePromise
		}
		// console.info("Initialize...")
		let initializePromiseResolve
		initializePromise = new Promise((res, rej) => {
			initializePromiseResolve = res
		})

		// DEBUG: this should be early enough to just overwrite the config
		let params = urlWatcher.readUrl()
		if (params.mock != null) {
			config.MOCK = params.mock == "true"
			window.localStorage.setItem(config.MOCK_COOKIE, config.MOCK.toString())
		}

		//get both infos, after this is we know if there is a valid basket and a valid user
		const accumulatorGroup = "initialize"
		let [existsResult, userResult] = await Promise.all([
			dispatch('cart/exists', { accumulatorGroup })
				.catch(e => Promise.resolve(e)),
			dispatch('account/getUser', { accumulatorGroup })
				.catch(e => Promise.resolve(e)),
		])
		// dispatch('getBrands', { accumulatorGroup });

		if (config.MOCK && config.MOCK_LOGIN) {
			//submit some mock data for the account
			await dispatch('login', {email: "fake@mock.ch", password: "blub"})
			await dispatch('account/loadQRToken')
			// console.log('QRCODE: ', `${config.ACCOUNT_QR_PREFIX}${getters['account/accountQrToken']}`)
		}

		if (config.LOCAL_TIME) {
			setLocalTimezone(config.LOCAL_TIME.substr(-6))
		}

		setTimeout(initializePromiseResolve, 0)
		return initializePromise
	},
	async initializeShoplist({ dispatch, state, commit, getters }) {
		await dispatch('initialize')
		await dispatch('cart/showContinue', false);

		try {
			if (service.mock) {
				await dispatch('debugFillCart')
			}
			if (!getters['cart/hasBasket']) {
				const params = getUrlParams();
				const referralToken = params.referralToken || params['referral-token'] || params['referral'] || cookie.get('referral') || null;
				const campaignId = params.mc_cid || cookie.get('mc_cid') || null;

				try {
					await dispatch('cart/open', {
						channel: config.DEFAULT_CHANNEL,
						orderNow: true,
						referralToken,
						campaignId,
					})
				}
				catch {
					return dispatch('redirect', {name: 'home'})
				}
			}
			await dispatch('updateShoplist')
		} catch(err) {
				throw err
		} finally {
			eventhub.$emit(EVENT_SHOP_INITIALIZED)
		}
	},

	async updateShoplist({ dispatch, state, getters, commit }) {
		const favoriteCode = getters['productlist/favoriteCode']
		await dispatch('productlist/loadCategories', { entrypoint: config.DEFAULT_ENTRYPOINT, accumulatorGroup: 'productListCategories' })

		let params = urlWatcher.readUrl()

		//read filters form html
		await dispatch('productlist/readFilters')

		//set filters active
		if (params.filters) {
			params.filters
				.split(",")
				.forEach(v => dispatch('productlist/setFilter', {filterId: v, active: true}))
		}

		let accumulatorGroup = "productList"
		let asyncQueue = []
		if (getters['account/isLoggedIn']) {
			let channel = state.cart.serverData ? state.cart.serverData.channel.code : null
			let shippingCode = (getters['cart/shippingMethod'] || {}).code
			asyncQueue.push(dispatch('account/loadLastOrders', { accumulatorGroup, channel, shippingCode }))
			asyncQueue.push(
				dispatch('account/loadFavoriteProducts', { accumulatorGroup })
				.catch(err => {
						// HACK: currently this endpoint does not work, so we resolve
					// console.warn('account/loadFavoriteProducts endpoint does not function (yet), fallback')
					return Promise.resolve([])
				})
			)
		}

		if (params.taxon) {
			// do not load this because its already here
			if ( params.taxon != favoriteCode) {
				asyncQueue.push(dispatch('productlist/loadProductList', { taxon: params.taxon, accumulatorGroup }))
			} else {
				commit('productlist/setActiveCategory', { item: favoriteCode })
			}
		} else {
			asyncQueue.push(dispatch('productlist/loadProductList', { accumulatorGroup }))
		}

		// fetch the whole queue
		return Promise.all(asyncQueue)
	},

	async initializeSidebarCart({ dispatch, state }) {
		await dispatch('initialize')
	},

	async debugFillCart({state, dispatch}) {
		//HACK: DEBUG CODE
		if (!state.cart.basketToken || state.cart.items.length < 1) {
			if (config.MOCK_CARTOPEN_FAILONCE) { // we have to deactivate this mock fail for the test
				tmpService.fakeFailOpenOnce = false
			}
			await dispatch('cart/open', { channel: "planzer" })
			await dispatch('cart/addItems', { items: [

			]})
			await dispatch('cart/addCoupon', {coupon: "test"})

			let childProductCode = '990000';
			await dispatch('childproducts/adjustChildProducts', {
				item: state.cart.items[2],
				childCodes: [childProductCode]
			})
		}
	},

	async initializeCheckout({ dispatch, state, getters }) {
		await dispatch('initialize')
		await dispatch('cart/showContinue', false);
		if (config.MOCK) {
			for (let type of ['', 'info', 'promo', 'success', 'warning', 'error']) {
				dispatch('notification/addMessage', {
					message: {
						"type": type,
						"message": type ? `This is a message of type: "${type}"` : 'This is a message with no type',
					}
				})
			}
		}

		//add messages from html
		if (config.messages) {
			config.messages
				.forEach(message => dispatch('notification/addMessage', { message }))
		}

		let asyncs = [
			dispatch('checkout/payments'),
			dispatch('checkout/summary')
		]
		if (getters['account/isLoggedIn']) {
			asyncs.push(dispatch('account/loadAddresses'))
		}

		try {
			await Promise.all(asyncs)

			if (service.mock) {
				await dispatch('debugFillCart')
			}
		} catch(err) {
			// console.error("Checkout::initialize -> redirect home", err)
			dispatch('redirect', {name: "home"})
		}

	},

	async initializeAccount({ dispatch, state, getters }) {
		await dispatch('initialize')
		if (getters['account/isLoggedIn']) {
			await dispatch('account/loadAddresses')
			await dispatch('account/loadLastOrders', { limit: 10 })
		}
	},

	async openCartAtChannel({dispatch, state}, {channel, zip, shippingCode, orderNow, deliverDate, deliverTime, deliverTimeslot, campaignId, replaceOldCart = false, referralToken = null}) {
		let orderTime;

		// HACK: we are not allowed to send orderNow to the service, so it cant be a normal boolean, same is for ordertime
		if (shippingCode != 'delivery') {
			orderNow = false
		} else if (orderNow) {
			orderTime = null
		}

		if (!orderNow) {
			let spl = deliverTime.split(":")
			orderTime = dayjsLocal(deliverDate).hour(spl[0]).minute(spl[1]).second(0)
		}

		await dispatch('cart/open', {
			channel,
			zip,
			shippingCode,
			orderNow,
			deliverTime: orderTime ? formatServer(orderTime) : null,
			deliverTimeslot,
			oldToken: replaceOldCart && state.cart.basketToken ? state.cart.basketToken : undefined,
			referralToken,
			campaignId,
		})

		eventhub.$emit(EVENT_CART_CREATED);

		const redirected = await dispatch('redirect', {name: "shop"});

		if (!redirected) {
			await dispatch('updateShoplist');
		}
	},

	async setShippingAddress({ dispatch, state, getters }, { form }) {
		let shippingAddress = {
			...form.shippingAddress,
			countryCode: form.shippingAddress.countryCode
				|| config.COUNTRY
		}
		let billingAddress = {
			...form.billingAddress,
			countryCode: form.billingAddress.countryCode
				|| config.COUNTRY
		}

		//we duplicate the shipping to billing if its empty
		//TODO: this check has some fail cases and it should not be required to check both
		if (!form.billingAddress.firstName || !form.billingAddress.lastName) {
			billingAddress = {
				...billingAddress,
				...shippingAddress
			}
		}

		await Promise.all([
			dispatch('checkout/setShipping', {
				...shippingAddress,
				accumulatorGroup: 'setAddress',
			}),
			dispatch('checkout/addressChange', {
				email: form.email,
				billingAddress,
				shippingAddress,
				accumulatorGroup: 'setAddress'
			}),
			dispatch('cart/load', { accumulatorGroup: 'setAddress' })
		])
		dispatch('checkout/setDeliveryMethod', getters['cart/shippingMethod'])
	},

	async submitOrder({ dispatch, state, getters }, { form, deliverTime }) {

		let order = {
			email: form.email,
			notes: form.notes,
			confirmedAlcohol: form.checkAlcohol,
			tip: form.tip ? form.tip : null, // HACK: yes, the api wants a null if its 0
			dropoffType: form.dropoffType,
			newsletter: form.newsletter,
			birthday: form.birthday,
			chopsticks: form.chopsticks,
		}

		let paymentAsync = null
		// check if there are available selectable payments, else we do have a zero Payment
		// TODO: this is an paradigm, it has to be written another way
		if (getters['checkout/checkoutPayments'].length === 0) {
			paymentAsync = Promise.resolve(true)
		} else {
			paymentAsync = dispatch('checkout/setPayment', { method: form.paymentCode })
		}

		let submitAsync = dispatch('checkout/submit', order)

		let [paymentResult, submitResult] = await Promise.all([paymentAsync, submitAsync])
		// console.info("results:", submitResult, paymentResult)
		if (submitResult && submitResult.error) {
			//submit error happend
			// short inline update of the cart
			await dispatch('cart/load')

			return Promise.reject(submitResult)
		} else {
			if (state.checkout.checkoutToken) {
				const order = await dispatch('checkout/order')
				if (order.payments.length > 0) {
					const paymentId = order.payments[0].method.code
					//TODO: detect datatrans other wayy
					if (paymentId == "cash") {
						//TODO: if we land here, we have to redirect to abort
						dispatch('redirect', {
							name: "checkout-complete",
							// url: format(config.CHECKOUT_COMPLETE_URL, {basketToken: order.tokenValue}),
							params: {basketToken: order.tokenValue}
						})
					} else {
						let datatransAdditional = {};

						if (paymentId == 'byjuno') {
							datatransAdditional = {
								...datatransAdditional,
								uppCustomerBirthDate: form.birthday,
								uppCustomerType: 'P',
								uppCustomerId: window.btoa(form.email).substr(0, 32),
								refno: order.number,
								intrumDeviceFingerprintId: 'DeviceFPMadameSum',
								intrumRiskOwner: 'IJ',
								sub_pmethod: 'INVOICE',
								intrumRepaymentType: 4,
								uppShippingDetails: 'no',
							}
						}

						try {
							await dispatch('payWithDatatrans', {
								order,
								email: form.email,
								additional: datatransAdditional
							})
						} catch(err) {
							if (err == "closed") {
								dispatch('redirect', {
									name: "checkout-cancel",
									// url: format(config.CHECKOUT_CANCEL_URL, {basketToken: order.tokenValue}),
									params: {basketToken: order.tokenValue}
								})
							}
						}
					}
				} else {
					// we didnt need payment, eg had voucher so we direct
					dispatch('redirect', {
						name: "checkout-complete",
						// url: format(config.CHECKOUT_COMPLETE_URL, {basketToken: order.tokenValue}),
						params: {basketToken: order.tokenValue}
					})
				}
			}
		}
	},

	async updateDeliverTime({ dispatch, state, getters }, { orderNow, date, time, timeslot, method, productCode, confirmChange }) {
		var spl = time.split(":")
		// this code could be rewritten to dynamic time getter
		var orderTime = dayjsLocal(date).hour(spl[0]).minute(spl[1]).second(0)
		await dispatch('cart/updateDeliverTime', { orderNow, deliverTime: formatServer(orderTime), deliverTimeslot: timeslot, deliverMethod: method, productCode, confirmChange })

		eventhub.$emit(EVENT_CART_TIMECHANGED)
	},

	async payWithDatatrans({state, dispatch}, {order, email, additional = {}}) {
		try {
			let articleCount = 1
			let currentPayment = order.payments[0]
			let currentShipment = order.shipments?.[0]?.method
			let paymentData = {
				currency: config.THEME_CURRENCY,
				amount: currentPayment.price.current,
				ref: order.number,
				merchantId: state.checkout.serverData
					? state.checkout.serverData.datatransMerchantId
					: config.CHECKOUT_MERCHANT_ID,
				sign: state.checkout.serverData
					? state.checkout.serverData.datatransSign
					: "",
				checkoutComplete: format(config.CHECKOUT_COMPLETE_URL, {basketToken: order.tokenValue}),
				successUrl: format(config.CHECKOUT_SUCCESS_URL, {basketToken: order.tokenValue}),
				cancelUrl: format(config.CHECKOUT_CANCEL_URL, {basketToken: order.tokenValue, channel: state.cart.basketChannel}),
				errorUrl: format(config.CHECKOUT_ERROR_URL, {basketToken: order.tokenValue, channel: state.cart.basketChannel}),
				additionalData: {
					language: config.LANGUAGE,
					uppCustomerLanguage: config.LANGUAGE,
					uppCustomerDetails: "yes",
					uppCustomerTitle: "",
					uppCustomerFirstName: order.billingAddress.firstName,
					uppCustomerLastName: order.billingAddress.lastName,
					uppCustomerStreet: `${order.billingAddress.street} ${order.billingAddress.streetNumber}`,
					uppCustomerStreet2: "",
					uppCustomerCity: order.billingAddress.city,
					uppCustomerCountry: order.billingAddress.countryCode,
					uppCustomerZipCode: order.billingAddress.postcode,
					uppCustomerPhone: order.billingAddress.phoneNumber,
					uppCustomerEmail: email,
					useAlias: true,
					uppRememberMe: "checked",
					uppStartTarget: '_top',
					...additional,
					...order.items.reduce((items, item, index) => {
						const i = {
							[`uppArticle_${articleCount}_Name`]: `${item.quantity}x ${item.product.variants?.[0]?.name ?? item.product.name}`,
							[`uppArticle_${articleCount}_Quantity`]: 1, //item.quantity,
							[`uppArticle_${articleCount}_Price`]: item.total,
							[`uppArticle_${articleCount}_Type`]: 'physical',
							[`uppArticle_${articleCount}_Tax`]: item.taxPercent ? item.taxPercent * 100 : 0,
							[`uppArticle_${articleCount}_TaxAmount`]: item.taxTotal ?? 0,
						}
						articleCount++;
						return {
							...items,
							...i
						}
					}, {}),
					[`uppArticle_${articleCount}_Name`]: currentShipment?.name || 'Delivery',
					[`uppArticle_${articleCount}_Quantity`]: 1,
					[`uppArticle_${articleCount}_Price`]: currentShipment?.price?.current || 0,
					[`uppArticle_${articleCount}_Type`]: 'shipping_fee',
					[`uppArticle_${articleCount}_Tax`]: 0,
					[`uppArticle_${articleCount}_TaxAmount`]: 0,
				}
			}
			if (currentPayment.method.datatransPaymentMethod) {
				paymentData.additionalData.paymentmethod = currentPayment.method.datatransPaymentMethod
			}

			dispatch('loader/setLoading', false); // loader would cover the datatrans overlay
			let result = await datatrans.payment(paymentData)
		} catch(err) {
			if (config.MOCK && err == "closed" ) {
				alert("MOCK: Datatrans Closed: redirect would happen now")
				return
			}
			throw err
		}

	},

	async login({ state, dispatch, commit }, { email, password }) {

		try {
			const response = await dispatch('account/login', { email, password, brand: config.BRAND })
			const accumulatorGroup = 'login'
			let channel = state.cart.serverData ? state.cart.serverData.channel.code : undefined
			let shippingCode = (getters['cart/shippingMethod'] || {}).code

			await Promise.all([
				dispatch('account/getUser', { accumulatorGroup }),
				dispatch('account/loadLastOrders', { accumulatorGroup, channel, shippingCode }),
				// HACK: currently we preload addresses on every login to group over accumulator
				dispatch('account/loadAddresses', { accumulatorGroup }),
				dispatch('account/loadFavoriteProducts', { accumulatorGroup })
					.catch(err => {
						 // HACK: currently this endpoint does not work, so we resolve
						// console.warn('account/loadFavoriteProducts endpoint does not function (yet), fallback')
						return Promise.resolve([])
					}),
			])

			eventhub.$emit(EVENT_ACCOUNT_ISLOGGEDIN)

			if (state.cart.basketToken) {
				dispatch('cart/load', { recalculate: true }).catch(err => {
					// do nothing
				});
			}

			return response;
		} catch(err) {
			throw err
		}
	},

	async logout({ state, dispatch, commit }) {
		dispatch('account/logout')
		dispatch('redirect', { name: 'logout-after' })
	},

	async register({ commit, dispatch, state }, { email, password, birthday, firstName, lastName, phoneNumber, checkTerms, userGroup, userCoupon, confirmUrl = '', recaptchaResponse}) {
		birthday = switchDateFormat(birthday, '-')
		try {
			return await dispatch('account/register', { email, password, birthday, firstName, lastName, phoneNumber, checkTerms, userGroup, userCoupon, registerConfirmUrl: confirmUrl || config.REGISTER_CONFIRM_URL, recaptchaResponse, brand: config.BRAND })
		} catch(err) {
			throw err
		}
	},

	async redoOrder({ commit, dispatch, state }, { token }) {
		try {
			await dispatch('cart/restoreOrder', { token })
			await dispatch('cart/load')
		} catch(err) {
			// console.error("could not restore", err)
		}
	},

	async redirect({dispatch}, {name, url, params = {}, force = false} = {}) {
		//TODO:
		const redirectMap = {
			"shop": config.SHOP_URL,
			"checkout": config.CHECKOUT_URL,
			"home": config.HOME_URL,
			"logout-after": config.LOGOUT_CONFIRM_URL,
			"account": config.ACCOUNT_URL,
			"checkout-cancel": config.CHECKOUT_CANCEL_URL,
			"checkout-failed": config.CHECKOUT_FAILED_URL,
			"checkout-success": config.CHECKOUT_SUCCESS_URL,
			"checkout-complete": config.CHECKOUT_COMPLETE_URL,
			"MIGRATION_URL": config.MIGRATION_URL,
			"MIGRATION_VERIFY_URL": config.MIGRATION_VERIFY_URL,
			"MIGRATION_VERIFY_RESEND_URL": config.MIGRATION_VERIFY_RESEND_URL,
			"custom": '',
		}
		if (redirectMap.hasOwnProperty(name)) {
			//TODO: remove this debug
			let newUrl = url || format(redirectMap[name], params)
			if (!newUrl) {
				return;
			}
			// console.debug("Redirect: ", name, newUrl)

			// helper for development
			const currentSearch = window.location.search
			if (currentSearch.includes('?_brand') && !newUrl.includes('?')) {
				newUrl += currentSearch
			}

			if (window.location.pathname != newUrl || force) {
				dispatch('loader/setLoading', true);
				window.location.href = newUrl
				return true
			} else {
				scrrroll.toTop()
				return false
			}
		}
	},

	async getBrands({commit}, { accumulatorGroup = null } = {}) {
		try {
			let result = await service.brands({ accumulatorGroup })
			commit('setBrands', { item: result.brands.map(brand => ({code: brand})) })
		} catch (err) {

		}
	},

	async subscribeNewsletter({ commit, dispatch, state }, { email, firstname, lastname, recaptchaResponse }) {
		try {
			return await service.subscribeNewsletter({ email, firstname, lastname, recaptchaResponse, brand: config.BRAND })
		} catch(err) {
			throw err
		}
	},

}
